import React from 'react';
import PropTypes from 'prop-types';

import Avatar from '../Avatar/Avatar';

import classNames from '../../utils/classNames';

import styles from './rich-card.scss';

export default function RichCard(props) {
    const { title, description, bottom, selectable, selected, ...restProps } = props;

    return (
        <div
            {...restProps}
            className={classNames(styles.wrapper, {
                [styles.selected]: selected,
                [styles.selectable]: selectable,
            })}
        >
            <div className={styles.content}>
                <Avatar text={title} size={'m'} />
                <div className={styles.center}>
                    <div className={styles.info}>
                        <h2>{title}</h2>
                        <p>{description}</p>
                    </div>
                    <div className={styles.bottom}>{bottom}</div>
                </div>
            </div>
        </div>
    );
}

RichCard.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    bottom: PropTypes.element,
    selectable: PropTypes.bool,
    selected: PropTypes.bool,
};
